<template>
  <!-- 右边信息 -->
  <div class="userCenter_right" v-loading="loading">
    <h4>企业信息认证</h4>
    <div class="steps_top">
      <el-steps :active="active" align-center>
        <el-step description="提交认证信息"></el-step>
        <el-step
          :class="status && status === 'REJECT' ? 'certificationErrorLine' : ''"
          description="认证信息审核"
        ></el-step>
        <el-step
          :class="status && status === 'REJECT' ? 'certificationError' : ''"
          :description="status && status === 'REJECT' ? '认证失败' : '完成认证'"
        ></el-step>
      </el-steps>
    </div>
    <!--认证状态-->
    <div class="certificationStatus" v-show="status && status !== 'APPROVE'">
      <img
        :src="status === 'SUBMIT'
      ? require('@/assets/auditIng.png')
      : require('@/assets/auditError.png')
    "
        alt
      />
      <div class="name">{{ status === "SUBMIT" ? "企业认证审核中" : "您的企业认证审核未通过" }}</div>
      <div class="message" v-if="status === 'SUBMIT'">
        请耐心等待审核结果（最长
        <span>3个工作日</span>）内完成审核
      </div>
      <div class="message" v-else>原因：{{ remark }}</div>
    </div>
    <img
      class="enterpriseCertificationSuccess"
      v-show="status && status === 'APPROVE'"
      src="@/assets/enterpriseCertificationSuccess.png"
      alt
    />
    <div class="right_idcar flex">
      <div
        ref="licenseUrlRef"
        :class="licenseUrlMessage !== ''
      ? 'messagesClass right_imgbox'
      : 'right_imgbox'
    "
      >
        <p>
          <span>*</span>上传企业证件附件
        </p>
        <el-upload
          action="/service-center/upload/file/single"
          :on-success="handleAvatarSuccess"
          class="hiddenInput"
          :headers="headers"
          :before-upload="beforeAvatarUpload"
          :disabled="status === 'SUBMIT'"
          :show-file-list="false"
        >
          <img v-if="!enterpriseCertificationForm.licenseUrl" :src="userInfo.avatar" alt />
          <img
            v-if="enterpriseCertificationForm.licenseUrl"
            :src="enterpriseCertificationForm.licenseUrl"
            alt
          />
        </el-upload>
        <p class="messagesPUrl">{{ licenseUrlMessage }}</p>
      </div>
      <div class="right_text">
        上传的图片格式要求jpg\jpeg\bmp\png,不超过10M，文件名（包含后缀名）的最大长度为100个字符。
        <br />可以添加”宁夏工业企业数字化转型公共服务平台备案、云服务申请、云服务认证、云服务备案“等水印；但不能遮挡关键信息，例如公司名称、公司证件号等。
      </div>
    </div>
    <div style="padding: 20px 30px 0 30px">
      <div class="enterBox flex">
        <div>
          <div
            ref="nameMessageRef"
            :class="nameMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>企业名称
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.name"
              :disabled="status === 'SUBMIT'"
              @blur="verifyNew('name')"
            />
            <p class="messagesP">{{ nameMessage }}</p>
          </div>
          <div
            ref="enterpriseTypeRef"
            :class="enterpriseTypeUuidMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>企业类型
              </p>
            </div>
            <el-select
              v-model="enterpriseCertificationForm.enterpriseTypeUuid"
              placeholder="请选择企业类型"
              :disabled="status === 'SUBMIT'"
              style="width: 334px;"
              @change="verifyNew('enterpriseTypeUuid')"
            >
              <el-option
                v-for="item in enterpriseTypeList"
                :key="item.uuid"
                :label="item.name"
                :value="item.uuid"
              ></el-option>
            </el-select>
            <p class="messagesP">{{ enterpriseTypeUuidMessage }}</p>
          </div>
          <div
            ref="registeredDateRef"
            :class="registeredDateMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>成立时间
              </p>
            </div>
            <el-date-picker
              v-model="enterpriseCertificationForm.registeredDate"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="status === 'SUBMIT'"
              @change="verifyNew('registeredDate')"
              placeholder="选择日期"
              style="width: 334px;"
            ></el-date-picker>
            <p class="messagesP">{{ registeredDateMessage }}</p>
          </div>
          <div
            ref="contactRef"
            :class="contactMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>联系人
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.contact"
              :disabled="status === 'SUBMIT'"
              @blur="verifyNew('contact')"
            />
            <p class="messagesP">{{ contactMessage }}</p>
          </div>
          <div
            ref="regionValueRef"
            :class="regionValueMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>注册地
              </p>
            </div>
            <el-cascader
              v-model="regionValue"
              :options="regionOptions"
              placeholder="省/市/区"
              :disabled="status === 'SUBMIT'"
              @change="verifyNew('regionValue')"
              style="width: 334px;"
            ></el-cascader>
            <p class="messagesP">{{ regionValueMessage }}</p>
          </div>
          <div
            ref="contactMailRef"
            :class="contactMailMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>联系邮箱
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.contactMail"
              @blur="verifyNew('contactMail')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ contactMailMessage }}</p>
          </div>
          <div
            ref="empNumRef"
            :class="empNumMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>员工人数
              </p>
            </div>
            <input
              type="text"
              style="width: 100px"
              v-model="enterpriseCertificationForm.empNum"
              @blur="verifyNew('empNum')"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ empNumMessage }}</p>
          </div>
        </div>
        <div>
          <div
            ref="creditCodeRef"
            :class="creditCodeMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>统一信用代码
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.creditCode"
              @blur="verifyNew('creditCode')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ creditCodeMessage }}</p>
          </div>
          <div
            ref="corporationRef"
            :class="corporationMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>法人
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.corporation"
              @blur="verifyNew('corporation')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ corporationMessage }}</p>
          </div>
          <div
            ref="registeredCapitalRef"
            :class="registeredCapitalMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>注册资本
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.registeredCapital"
              @blur="verifyNew('registeredCapital')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ registeredCapitalMessage }}</p>
          </div>
          <div
            ref="businessTermRef"
            :class="businessTermMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>营业期限
              </p>
            </div>
            <el-date-picker
              v-model="enterpriseCertificationForm.businessTerm"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="status === 'SUBMIT'"
              @change="verifyNew('businessTerm')"
              placeholder="选择日期"
              style="width: 334px;"
            ></el-date-picker>
            <p class="messagesP">{{ businessTermMessage }}</p>
          </div>
          <div
            ref="regionValueRef"
            :class="addressMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>详细地址
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.address"
              @blur="verifyNew('address')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ addressMessage }}</p>
          </div>
          <div
            :class="contactTelMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>
                <span>*</span>联系电话
              </p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.contactTel"
              @blur="verifyNew('contactTel')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ contactTelMessage }}</p>
          </div>
          <div
            :class="webSiteMessage !== ''
      ? 'messagesClass flex enterBox_input'
      : 'flex enterBox_input'
    "
          >
            <div class="justEnter">
              <p>企业网址</p>
            </div>
            <input
              type="text"
              v-model="enterpriseCertificationForm.webSite"
              @blur="verifyNew('webSite')"
              :disabled="status === 'SUBMIT'"
            />
            <p class="messagesP">{{ webSiteMessage }}</p>
          </div>
        </div>
      </div>
      <!-- <div :class="regionUuidMessage !== ''
      ? 'messagesClass flex enterBox_input2'
      : 'flex enterBox_input2'
    ">
        <div class="justEnter">
          <p style="line-height: 12px;">所属区域</p>
        </div>
        <div>
          <el-select v-model="enterpriseCertificationForm.regionUuid" placeholder="请选择" clearable style="width: 334px;">
            <el-option v-for="item in regionDataList" :key="item.uuid" :label="item.name" :value="item.uuid">
            </el-option>
          </el-select>
        </div>
        <p class="messagesP">{{ regionUuidMessage }}</p>
      </div>-->
      <div
        ref="businessScopeRef"
        :class="businessScopeMessage !== ''
      ? 'messagesClass flex enterBox_input2'
      : 'flex enterBox_input2'
    "
      >
        <div class="justEnter">
          <p>
            <span>*</span>经营范围
          </p>
        </div>
        <textarea
          type="text"
          v-model="enterpriseCertificationForm.businessScope"
          @blur="verifyNew('businessScope')"
          :disabled="status === 'SUBMIT'"
        />
        <p class="messagesP">{{ businessScopeMessage }}</p>
      </div>
      <div
        ref="productsRef"
        :class="productsMessage !== ''
      ? 'messagesClass flex enterBox_input2'
      : 'flex enterBox_input2'
    "
      >
        <div class="justEnter">
          <p>
            <span>*</span>主营产品
          </p>
        </div>
        <textarea
          type="text"
          @blur="verifyNew('products')"
          v-model="enterpriseCertificationForm.products"
          :disabled="status === 'SUBMIT'"
        />
        <p class="messagesP">{{ productsMessage }}</p>
      </div>
      <div
        ref="descriptionRef"
        :class="descriptionMessage !== ''
      ? 'messagesClass flex enterBox_input2'
      : 'flex enterBox_input2'
    "
      >
        <div class="justEnter">
          <p>
            <span>*</span>公司简介
          </p>
        </div>
        <div>
          <vue-editor
            useCustomImageHandler
            @image-added="handleImageAdded"
            @blur="verifyNew('description')"
            :disabled="status === 'SUBMIT'"
            v-model="enterpriseCertificationForm.description"
          ></vue-editor>
          <!-- useCustomImageHandler 开启自定义图片上传功能
          @image-added 点击上传图片按钮时候的钩子-->
          <p class="messagesP">{{ descriptionMessage }}</p>
        </div>
      </div>
      <div class="checkText">
        <el-checkbox v-model="checked" :disabled="status === 'SUBMIT'"></el-checkbox>
        <p>请务必提供真实信息，宁夏工业企业数字化转型公共服务平台公司有权自行或履行第三方，审核您提供的身份信息是否真实、有效。若提供虚假信息，由此带来的全部结果由您承担。</p>
      </div>
    </div>
    <div class="certibutton">
      <!--<p v-show="status"-->
      <!--:class="status === 'SUBMIT'?'tipClass tipClassWait':status === 'APPROVE'?'tipClass tipClassSuccess':'tipClass tipClassError'">-->
      <!--{{status === 'SUBMIT'?'正在认证审核中':status === 'APPROVE'?'认证成功':'认证失败'}}-->
      <!--<i :class="status === 'SUBMIT'?'el-icon-refresh-right':status === 'APPROVE'?'el-icon-circle-check':'el-icon-circle-close'"></i>-->
      <!--</p> :disabled="!checked"-->
      <button @click="submit" v-show="status !== 'SUBMIT'">
        {{
        !status ? "提交" : status === "APPROVE" ? "修改认证信息" : "提交认证"
        }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  getEnterpriseCredentials,
  submitEnterpriseCredentials,
  amendEnterpriseCredentials,
  getIndexDictionaryData,
  getLicenseInformation,
  getParkList,
  single,
  validCode,
  validName,
  getDictionaryItem
} from "../../../utils/interface";
import provinceData from "../../../utils/provinceData";
import { VueEditor } from "vue2-editor";

export default {
  //   企业认证
  name: "EnterCertification",
  components: {
    VueEditor
  },
  data() {
    return {
      regionDataList: [],
      loading: false,
      active: 1,
      status: "",
      uuid: "",
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      enterpriseTypeList: [],
      enterpriseCertificationForm: {
        uuid: "",
        address: "", //详细地址
        businessScope: "", //经营范围
        businessTerm: "", //经营期限
        city: "", //市
        contact: "", //联系人
        contactMail: "", //联系邮箱
        contactTel: "", //联系电话
        corporation: "", //法人
        creditCode: "", //统一社会信用编码
        description: "", //企业介绍
        district: "", //区
        empNum: "", //人数
        regionUuid: "", //所属区域
        enterpriseTypeUuid: "", //企业类型
        licenseUrl: "", //营业执照地址
        name: "", //名称
        products: "", //主营产品
        province: "", //省份
        registeredCapital: "", //注册资金
        registeredDate: "", //注册日期
        webSite: "" //网址
      },
      // 上传身份证
      userInfo: {
        avatar: require("../../../assets/xukezheng.png")
      },
      // 地区选择
      regionValue: "",
      regionOptions: provinceData,
      checked: false,
      remark: "",
      addressMessage: "", //详细地址提示
      businessScopeMessage: "", //经营范围提示
      businessTermMessage: "", //经营期限提示
      contactMessage: "", //联系人提示
      contactMailMessage: "", //联系邮箱提示
      contactTelMessage: "", //联系电话提示
      corporationMessage: "", //法人提示
      creditCodeMessage: "", //统一社会信用编码提示
      descriptionMessage: "", //企业介绍提示
      empNumMessage: "", //人数提示
      regionUuidMessage: "", // 所属区域
      enterpriseTypeUuidMessage: "", //企业类型提示
      licenseUrlMessage: "", //营业执照地址提示
      nameMessage: "", //名称提示
      productsMessage: "", //主营产品提示
      registeredCapitalMessage: "", //注册资金提示
      registeredDateMessage: "", //注册日期提示
      regionValueMessage: "", //地区提示
      webSiteMessage: "" //网址
    };
  },
  created() {
    this.getRegionData();
  },
  methods: {
    getRegionData() {
      getDictionaryItem({ groupCode: "regionList" }).then(resp => {
        this.regionDataList = resp;
      });
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log('图片上传', );
      var formData = new FormData();
      formData.append("file", file); //第一个file 后台接收的参数名
      let res = await single(formData);
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url);
        resetUploader();
      } else {
        alert("上传返回失败");
      }
    },
    // 上传企业证件
    beforeAvatarUpload(file) {
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      let fileTypes = [
        ".jpg",
        ".png",
        ".jpeg",
        ".bmp",
        ".JPG",
        ".PNG",
        ".JPEG",
        ".BMP"
      ];
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      let fileIndex = fileTypes.indexOf(fileTypeName);
      if (fileIndex === -1) {
        this.$alert("只能上传jpg/jpeg/bmp/png格式图片", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!isLt10M) {
        this.$alert("图片大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileIndex !== -1 && fileNameLength;
    },
    handleAvatarSuccess(obj, fileList) {
      this.loading = true;
      let data = {
        url: obj.url
      };
      getLicenseInformation(data)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.enterpriseCertificationForm.licenseUrl = obj.url;
            this.enterpriseCertificationForm.businessScope = res.data
              .businessScope
              ? res.data.businessScope
              : this.enterpriseCertificationForm.businessScope;
            this.enterpriseCertificationForm.name = res.data.name
              ? res.data.name
              : this.enterpriseCertificationForm.name;
            this.enterpriseCertificationForm.enterpriseTypeUuid = res.data
              .enterpriseTypeUuid
              ? res.data.enterpriseTypeUuid
              : this.enterpriseCertificationForm.enterpriseTypeUuid;
            this.enterpriseCertificationForm.creditCode = res.data.creditCode
              ? res.data.creditCode
              : this.enterpriseCertificationForm.creditCode;
            this.enterpriseCertificationForm.corporation = res.data.corporation
              ? res.data.corporation
              : this.enterpriseCertificationForm.corporation;
            this.enterpriseCertificationForm.registeredDate = res.data
              .registeredDate
              ? res.data.registeredDate
              : this.enterpriseCertificationForm.registeredDate;
            this.enterpriseCertificationForm.registeredCapital = res.data
              .registeredCapital
              ? res.data.registeredCapital
              : this.enterpriseCertificationForm.registeredCapital;
            this.enterpriseCertificationForm.address = res.data.address
              ? res.data.address
              : this.enterpriseCertificationForm.address;
            this.enterpriseCertificationForm.businessTerm = res.data
              .businessTerm
              ? res.data.businessTerm
              : this.enterpriseCertificationForm.businessTerm;
            if (res.data.district && res.data.province && res.data.city) {
              this.enterpriseCertificationForm.district = res.data.district;
              this.enterpriseCertificationForm.province = res.data.province;
              this.enterpriseCertificationForm.city = res.data.city;
              this.regionValue = [];
              if (this.enterpriseCertificationForm.district) {
                this.regionValue = [
                  this.enterpriseCertificationForm.province,
                  this.enterpriseCertificationForm.city,
                  this.enterpriseCertificationForm.district
                ];
              } else {
                this.regionValue = [
                  this.enterpriseCertificationForm.province,
                  this.enterpriseCertificationForm.city
                ];
              }
            }
          } else {
            this.enterpriseCertificationForm = {
              address: "", //详细地址
              businessScope: "", //经营范围
              businessTerm: "", //经营期限
              city: "", //市
              contact: "", //联系人
              contactMail: "", //联系邮箱
              contactTel: "", //联系电话
              corporation: "", //法人
              creditCode: "", //统一社会信用编码
              description: "", //企业介绍
              district: "", //区
              empNum: "", //人数
              regionUuid: "", // 所在园区
              enterpriseTypeUuid: "", //企业类型
              licenseUrl: obj.url, //营业执照地址
              name: "", //名称
              products: "", //主营产品
              province: "", //省份
              registeredCapital: "", //注册资金
              registeredDate: "", //注册日期
              webSite: "" //网址
            };
            // this.$alert('上传成功，请输入企业信息！', "提示", {
            //     confirmButtonText: "确定",
            // })
          }
          this.verifyNew("licenseUrl");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 富文本
    // handleImageAdded(file, Editor, cursorLocation, resetUploader) {
    //   // console.log(file, Editor, cursorLocation, resetUploader);
    //   let formData = new FormData();
    //   // image是请求参数
    //   formData.append("image", file);
    //   // 上传图片接口
    //   // const res = api.post("upload", formData);
    // },
    // 根据用户获取企业认证信息
    getEnterpriseUserCredentials() {
      getIndexDictionaryData({
        groupCode: "enterprise_type"
      }).then(res => {
        this.enterpriseTypeList = res;
      });
      this.loading = true;
      getEnterpriseCredentials()
        .then(res => {
          this.loading = false;
          this.reset();
          if (res.success) {
            this.status = res.data.status;
            this.remark = res.data.remark;
            this.uuid = res.data.uuid;
            this.enterpriseCertificationForm = res.data;
            this.regionValue = [];
            if (this.enterpriseCertificationForm.district) {
              this.regionValue = [
                this.enterpriseCertificationForm.province,
                this.enterpriseCertificationForm.city,
                this.enterpriseCertificationForm.district
              ];
            } else {
              this.regionValue = [
                this.enterpriseCertificationForm.province,
                this.enterpriseCertificationForm.city
              ];
            }
            this.checked = true;
            if (this.status === "SUBMIT") {
              this.active = 2;
            } else {
              this.active = 3;
            }
          } else {
            this.status = "";
            this.active = 1;
            this.regionValue = [];
            this.checked = false;
            Object.assign({}, this.enterpriseCertificationForm);
          }
        })
        .catch(() => {
          this.loading = false;
          this.status = "";
          this.active = 1;
          this.regionValue = [];
          Object.assign({}, this.enterpriseCertificationForm);
          this.loading = false;
        });
    },
    // 提交
    submit() {
      console.log("jfkaj", this.enterpriseCertificationForm.description);
      if (this.submitCheck()) {
        if (this.regionValue.length === 3) {
          this.enterpriseCertificationForm.province = this.regionValue[0];
          this.enterpriseCertificationForm.city = this.regionValue[1];
          this.enterpriseCertificationForm.district = this.regionValue[2];
        } else {
          this.enterpriseCertificationForm.province = this.regionValue[0];
          this.enterpriseCertificationForm.city = this.regionValue[1];
          this.enterpriseCertificationForm.district = "";
        }
        let data = this.enterpriseCertificationForm;
        this.loading = true;
        if (!this.status) {
          submitEnterpriseCredentials(data)
            .then(res => {
              this.loading = false;
              if (res.success) {
                this.$alert(res.message, "提示", {
                  confirmButtonText: "确定"
                });
                this.getEnterpriseUserCredentials();
              } else {
                this.$alert("提交失败！", "提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$set(data, "uuid", this.uuid);
          amendEnterpriseCredentials(data, this.uuid)
            .then(res => {
              this.loading = false;
              if (res.success) {
                this.$alert(res.message, "提示", {
                  confirmButtonText: "确定"
                });
                this.getEnterpriseUserCredentials();
              } else {
                this.$alert("提交失败！", "提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      }
    },
    // 提交校验
    submitCheck() {
      if (
        this.enterpriseCertificationForm.licenseUrl &&
        this.enterpriseCertificationForm.name &&
        this.enterpriseCertificationForm.creditCode &&
        this.enterpriseCertificationForm.enterpriseTypeUuid &&
        this.enterpriseCertificationForm.corporation &&
        this.enterpriseCertificationForm.registeredDate &&
        this.enterpriseCertificationForm.registeredCapital &&
        this.enterpriseCertificationForm.contact &&
        this.enterpriseCertificationForm.businessTerm &&
        this.regionValue &&
        this.enterpriseCertificationForm.address &&
        this.enterpriseCertificationForm.contactMail &&
        this.validate.isEmail(this.enterpriseCertificationForm.contactMail) &&
        this.enterpriseCertificationForm.contactTel &&
        this.validate.isMobile(this.enterpriseCertificationForm.contactTel) &&
        this.enterpriseCertificationForm.empNum &&
        this.enterpriseCertificationForm.businessScope &&
        this.enterpriseCertificationForm.products &&
        this.enterpriseCertificationForm.description
      ) {
        if (this.enterpriseCertificationForm.webSite) {
          if (this.validate.isURL(this.enterpriseCertificationForm.webSite)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        // console.log('232',this.$refs.nameMessageRef );

        if (!this.enterpriseCertificationForm.licenseUrl) {
          this.licenseUrlMessage = "请上传企业证件附件";
          document.documentElement.scrollTop = this.$refs[
            "licenseUrlRef"
          ].offsetTop;
        } else {
          this.licenseUrlMessage = "";
        }
        if (!this.enterpriseCertificationForm.name) {
          this.nameMessage = "请输入企业名称";
          document.documentElement.scrollTop = this.$refs[
            "nameMessageRef"
          ].offsetTop;
        } else {
          this.validNameMess();
          // this.nameMessage = ''
        }
        if (!this.enterpriseCertificationForm.creditCode) {
          this.creditCodeMessage = "请输入统一社会信用编码";
          document.documentElement.scrollTop = this.$refs[
            "creditCodeRef"
          ].offsetTop;
        } else {
          // this.creditCodeMessage = ''
          this.validCodeMess();
        }
        if (!this.enterpriseCertificationForm.enterpriseTypeUuid) {
          this.enterpriseTypeUuidMessage = "请选择企业类型";
          document.documentElement.scrollTop = this.$refs[
            "enterpriseTypeRef"
          ].offsetTop;
        } else {
          this.enterpriseTypeUuidMessage = "";
        }
        if (!this.enterpriseCertificationForm.corporation) {
          this.corporationMessage = "请输入法人";
          document.documentElement.scrollTop = this.$refs[
            "corporationRef"
          ].offsetTop;
        } else {
          this.corporationMessage = "";
        }
        if (!this.enterpriseCertificationForm.registeredDate) {
          this.registeredDateMessage = "请选择成立时间";
          document.documentElement.scrollTop = this.$refs[
            "registeredDateRef"
          ].offsetTop;
        } else {
          this.registeredDateMessage = "";
        }
        if (!this.enterpriseCertificationForm.registeredCapital) {
          this.registeredCapitalMessage = "请输入注册资本";
          document.documentElement.scrollTop = this.$refs[
            "registeredCapitalRef"
          ].offsetTop;
        } else {
          this.registeredCapitalMessage = "";
        }
        if (!this.enterpriseCertificationForm.contact) {
          this.contactMessage = "请输入联系人";
          document.documentElement.scrollTop = this.$refs[
            "contactRef"
          ].offsetTop;
        } else {
          this.contactMessage = "";
        }
        if (!this.enterpriseCertificationForm.businessTerm) {
          this.businessTermMessage = "请选择营业期限";
          document.documentElement.scrollTop = this.$refs[
            "businessTermRef"
          ].offsetTop;
        } else {
          this.businessTermMessage = "";
        }
        if (!this.regionValue) {
          this.regionValueMessage = "请选择注册地";
          document.documentElement.scrollTop = this.$refs[
            "regionValueRef"
          ].offsetTop;
        } else {
          this.regionValueMessage = "";
        }
        if (!this.enterpriseCertificationForm.address) {
          this.addressMessage = "请输入详细地址";
          document.documentElement.scrollTop = this.$refs[
            "regionValueRef"
          ].offsetTop;
        } else {
          this.addressMessage = "";
        }
        if (!this.enterpriseCertificationForm.contactMail) {
          this.contactMailMessage = "请输入联系邮箱";
          document.documentElement.scrollTop = this.$refs[
            "contactMailRef"
          ].offsetTop;
        } else {
          if (
            !this.validate.isEmail(this.enterpriseCertificationForm.contactMail)
          ) {
            this.contactMailMessage = "请输入正确的邮箱地址";
            document.documentElement.scrollTop = this.$refs[
              "contactMailRef"
            ].offsetTop;
          } else {
            this.contactMailMessage = "";
          }
        }
        if (!this.enterpriseCertificationForm.contactTel) {
          this.contactTelMessage = "请输入联系电话";
          document.documentElement.scrollTop = this.$refs[
            "contactMailRef"
          ].offsetTop;
        } else {
          if (
            !this.validate.isMobile(this.enterpriseCertificationForm.contactTel)
          ) {
            this.contactTelMessage = "请输入正确的联系电话";
            document.documentElement.scrollTop = this.$refs[
              "contactMailRef"
            ].offsetTop;
          } else {
            this.contactTelMessage = "";
          }
        }
        if (!this.enterpriseCertificationForm.empNum) {
          this.empNumMessage = "请输入员工人数";
          document.documentElement.scrollTop = this.$refs[
            "empNumRef"
          ].offsetTop;
        } else {
          this.empNumMessage = "";
        }
        if (!this.enterpriseCertificationForm.businessScope) {
          this.businessScopeMessage = "请输入经营范围";
          document.documentElement.scrollTop = this.$refs[
            "businessScopeRef"
          ].offsetTop;
        } else {
          this.businessScopeMessage = "";
        }
        if (!this.enterpriseCertificationForm.products) {
          this.productsMessage = "请输入主营产品";
          document.documentElement.scrollTop = this.$refs[
            "productsRef"
          ].offsetTop;
        } else {
          this.productsMessage = "";
        }
        if (!this.enterpriseCertificationForm.description) {
          this.descriptionMessage = "请输入公司简介";
          document.documentElement.scrollTop = this.$refs[
            "descriptionRef"
          ].offsetTop;
        } else {
          this.descriptionMessage = "";
        }
        if (
          this.enterpriseCertificationForm.webSite &&
          !this.validate.isURL(this.enterpriseCertificationForm.webSite)
        ) {
          this.webSiteMessage =
            "请输入正确的企业网址,如https://www.shuibengcloud.com";
        } else {
          this.webSiteMessage = "";
        }
        return false;
      }
    },
    // 统一
    validCodeMess() {
      let params = {
        code: this.enterpriseCertificationForm.creditCode,
        uuid: this.enterpriseCertificationForm.uuid
      };
      validCode(params).then(res => {
        if (!res) {
          this.creditCodeMessage = "统一社会信用代码已存在请核对后再填写";
        } else {
          if (
            this.validate.creditCode(
              this.enterpriseCertificationForm.creditCode
            )
          ) {
            this.creditCodeMessage = "";
          } else {
            this.creditCodeMessage = "请输入正确的统一社会信用代码";
          }
        }
      });
    },
    // 企业名称
    validNameMess() {
      let params = {
        name: this.enterpriseCertificationForm.name,
        uuid: this.enterpriseCertificationForm.uuid
      };
      validName(params).then(res => {
        if (!res) {
          this.nameMessage = "企业名称已存在请核对后再填写";
        } else {
          this.nameMessage = "";
        }
      });
    },
    // 校验文字显示方式
    verifyNew(val) {
      if (val === "licenseUrl") {
        if (!this.enterpriseCertificationForm.licenseUrl) {
          this.licenseUrlMessage = "请上传企业证件附件";
        } else {
          this.licenseUrlMessage = "";
        }
      }
      if (val === "name") {
        if (!this.enterpriseCertificationForm.name) {
          this.nameMessage = "请输入企业名称";
        } else {
          this.validNameMess();
        }
      }
      if (val === "creditCode") {
        if (!this.enterpriseCertificationForm.creditCode) {
          this.creditCodeMessage = "请输入统一社会信用代码";
        } else {
          this.validCodeMess();
        }
      }
      if (val === "enterpriseTypeUuid") {
        if (!this.enterpriseCertificationForm.enterpriseTypeUuid) {
          this.enterpriseTypeUuidMessage = "请选择企业类型";
        } else {
          this.enterpriseTypeUuidMessage = "";
        }
      }
      if (val === "corporation") {
        if (!this.enterpriseCertificationForm.corporation) {
          this.corporationMessage = "请输入法人";
        } else {
          this.corporationMessage = "";
        }
      }
      if (val === "registeredDate") {
        if (!this.enterpriseCertificationForm.registeredDate) {
          this.registeredDateMessage = "请选择成立时间";
        } else {
          this.registeredDateMessage = "";
        }
      }
      if (val === "registeredCapital") {
        if (!this.enterpriseCertificationForm.registeredCapital) {
          this.registeredCapitalMessage = "请输入注册资本";
        } else {
          this.registeredCapitalMessage = "";
        }
      }
      if (val === "contact") {
        if (!this.enterpriseCertificationForm.contact) {
          this.contactMessage = "请输入联系人";
        } else {
          this.contactMessage = "";
        }
      }
      if (val === "businessTerm") {
        if (!this.enterpriseCertificationForm.businessTerm) {
          this.businessTermMessage = "请选择营业期限";
        } else {
          this.businessTermMessage = "";
        }
      }
      if (val === "regionValue") {
        if (!this.regionValue) {
          this.regionValueMessage = "请选择注册地";
        } else {
          this.regionValueMessage = "";
        }
      }
      if (val === "address") {
        if (!this.enterpriseCertificationForm.address) {
          this.addressMessage = "请输入详细地址";
        } else {
          this.addressMessage = "";
        }
      }
      if (val === "contactMail") {
        if (!this.enterpriseCertificationForm.contactMail) {
          this.contactMailMessage = "请输入联系邮箱";
        } else {
          if (
            !this.validate.isEmail(this.enterpriseCertificationForm.contactMail)
          ) {
            this.contactMailMessage = "请输入正确的邮箱地址";
          } else {
            this.contactMailMessage = "";
          }
        }
      }
      if (val === "contactTel") {
        if (!this.enterpriseCertificationForm.contactTel) {
          this.contactTelMessage = "请输入联系电话";
        } else {
          if (
            !this.validate.isMobile(this.enterpriseCertificationForm.contactTel)
          ) {
            this.contactTelMessage = "请输入正确的联系电话";
          } else {
            this.contactTelMessage = "";
          }
        }
      }
      if (val === "empNum") {
        if (!this.enterpriseCertificationForm.empNum) {
          this.empNumMessage = "请输入员工人数";
        } else {
          this.empNumMessage = "";
        }
      }

      if (val === "businessScope") {
        if (!this.enterpriseCertificationForm.businessScope) {
          this.businessScopeMessage = "请输入经营范围";
        } else {
          this.businessScopeMessage = "";
        }
      }
      if (val === "products") {
        if (!this.enterpriseCertificationForm.products) {
          this.productsMessage = "请输入主营产品";
        } else {
          this.productsMessage = "";
        }
      }
      if (val === "description") {
        if (!this.enterpriseCertificationForm.description) {
          this.descriptionMessage = "请输入公司简介";
        } else {
          this.descriptionMessage = "";
        }
      }
      if (val === "webSite") {
        if (
          this.enterpriseCertificationForm.webSite &&
          !this.validate.isURL(this.enterpriseCertificationForm.webSite)
        ) {
          this.webSiteMessage =
            "请输入正确的企业网址,如https://www.shuibengcloud.com";
        } else {
          this.webSiteMessage = "";
        }
      }
    },
    // 重置校验提示
    reset() {
      this.addressMessage = "";
      this.businessScopeMessage = "";
      this.businessTermMessage = "";
      this.contactMessage = "";
      this.contactMailMessage = "";
      this.contactTelMessage = "";
      this.corporationMessage = "";
      this.creditCodeMessage = "";
      this.descriptionMessage = "";
      this.empNumMessage = "";
      this.regionUuidMessage = "";
      this.enterpriseTypeUuidMessage = "";
      this.licenseUrlMessage = "";
      this.nameMessage = "";
      this.productsMessage = "";
      this.registeredCapitalMessage = "";
      this.registeredDateMessage = "";
      this.regionValueMessage = "";
      this.webSiteMessage = "";
    }
  }
};
</script>
<style scoped lang="less">
.blue {
  color: #2d50a1;
}

.red {
  color: #d60000;
}

.messagesP {
  padding: 0 !important;
  margin: 0 !important;
  color: #ff0000 !important;
  position: absolute;
  bottom: -26px;
  left: 101px;
  font-size: 13px;
}

.messagesPUrl {
  padding: 0 !important;
  margin: 0 !important;
  color: #ff0000 !important;
  position: absolute;
  bottom: 0;
  left: 0;
}

.enterpriseCertificationSuccess {
  position: absolute;
  right: 60px;
  top: 160px;
  width: 200px;
  height: 200px;
}

.certificationErrorLine {
  /deep/ .el-step__head.is-finish {
    .el-step__line {
      border-color: #f66f6a !important;
    }
  }
}

.certificationError {
  /deep/ .el-step__head.is-finish {
    color: #f66f6a;
    border-color: #f66f6a !important;
  }

  /deep/ .el-step__description.is-finish {
    color: #f66f6a;
  }
}

.tipClass {
  margin-left: 18px;
  height: 45px;
  box-sizing: border-box;
  border-radius: 10px;
  line-height: 45px;
  text-align: center;
  background: #e2efff;
  padding: 0 20px;
  width: max-content;
  font-size: 14px;
  font-weight: bold;

  i {
    font-size: 16px;
    font-weight: bold;
  }
}

.tipClassSuccess {
  color: #00b11d;
  background: #d6f3d7;
}

.tipClassError {
  color: #ff8000;
  background: #ffd6ae;
}

.tipClassWait {
  color: #2d50a1;
  background: #e2efff;
}

.userCenter_right {
  width: 966px;
  background: #fff;
  position: relative;

  /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #2d50a1;
    border-color: #2d50a1;
    cursor: default;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    border: 1px solid #dcdfe6;
    color: #606266;
    background-color: #fff;
    cursor: default;
  }

  /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #fff;
  }

  h4 {
    // color: #2d50a1;
    padding: 20px 18px;
    border-bottom: 2px solid #f9f9f9;
  }

  .steps_top {
    padding: 20px 18px;

    /deep/ .el-step.is-center .el-step__description {
      margin-top: 10px;
    }

    /deep/ .el-step__icon {
      width: 35px;
      height: 35px;
    }

    /deep/ .el-step.is-horizontal .el-step__line {
      top: 17px;
    }

    /deep/ .el-step__head.is-process {
      color: #c0c4cc;
      border-color: #c0c4cc;
    }

    /deep/.el-step__head.is-finish {
      color: #2d50a1;
      border-color: #2d50a1;
    }

    /deep/.el-step__description.is-finish {
      color: #2d50a1;
    }
  }

  .right_idcar {
    // justify-content: space-between;
    padding: 30px 30px 0;

    .right_imgbox {
      flex-shrink: 0;
      width: 220px;
      margin-right: 15px;

      p {
        margin-bottom: 10px;
        font-size: 14px;
        color: #555;
        position: relative;

        span {
          position: absolute;
          left: -10px;
          top: 0;
          color: #f56c6c;
        }
      }

      img {
        width: 220px;
        height: 138px;
      }
    }

    .right_text {
      width: 348px;
      font-size: 13px;
      color: #888;
      margin-top: 25px;
      line-height: 22px;
    }

    .hiddenInput2 {
      display: none;
    }
  }

  .certibutton {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 20px;

    button {
      cursor: pointer;
      min-width: 70px;
      height: 38px;
      background: #2d50a1;
      border-radius: 5px;
      color: #fff;
      line-height: 38px;
      border: none;
      padding: 0 10px;
    }

    button[disabled] {
      background: #c0c4cc;
      cursor: not-allowed;
    }
  }

  .certificationStatus {
    text-align: center;
    margin: 0 auto;
    width: 500px;
    padding: 20px 0 50px;

    img {
      margin-bottom: 15px;
    }

    .name {
      color: #333;
      font-size: 20px;
      padding-bottom: 10px;
    }

    .message {
      font-size: 14px;
      color: #555;

      span {
        font-weight: bold;
        color: #000;
      }
    }
  }

  .enterBox {
    font-size: 14px;
    justify-content: space-between;
  }

  .enterBox_input {
    // width: 50%;
    align-items: center;
    margin-bottom: 42px;
    position: relative;

    &.messagesClass {
      input {
        border: 1px solid #ff0000;
      }

      /deep/ .el-input__inner {
        border: 1px solid #ff0000;
      }
    }

    .justEnter {
      min-width: 86px;
      text-align: justify;
      margin-right: 10px;

      p {
        flex-shrink: 0;
        line-height: 0;
        position: relative;

        span {
          position: absolute;
          left: -10px;
          top: 0;
          color: #f56c6c;
        }
      }

      p::after {
        content: "";
        width: 100%;
        display: inline-block;
      }
    }

    input {
      border: 1px solid transparent;
      background: #fafafa;
      flex-shrink: 0;
      border-radius: 5px;
      width: 334px;
      height: 40px;
      padding-left: 10px;
    }
  }

  .enterBox_input2 {
    margin-bottom: 42px;
    font-size: 14px;
    position: relative;

    &.messagesClass {
      textarea {
        border: 1px solid #ff0000;
      }

      /deep/ .quillWrapper {
        border: 1px solid red;
      }
    }

    /deep/ .el-radio {
      margin-bottom: 10px;
    }

    .justEnter {
      min-width: 86px;
      text-align: justify;
      margin-right: 10px;
      margin-top: 12px;

      p {
        flex-shrink: 0;
        line-height: 0;
        position: relative;

        span {
          position: absolute;
          left: -10px;
          top: 0;
          color: #f56c6c;
        }
      }

      p::after {
        content: "";
        width: 100%;
        display: inline-block;
      }
    }

    textarea {
      width: 90%;
      height: 95px;
      border: 1px solid transparent;
      background: #fafafa;
      border-radius: 5px;
      padding-left: 10px;
      padding-top: 10px;
    }
  }

  .checkText {
    font-size: 14px;
    color: #555;
    display: flex;

    /deep/.el-checkbox__inner {
      border: 1px solid #2d50a1;
    }

    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2d50a1;
    }

    p {
      margin-left: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/certificationCenter/enterCertification.vue